import { useMemo } from 'react'
import type { CommandPaletteItem } from '../types'

export const useCommandPaletteSearch = (
  items: CommandPaletteItem[],
  searchQuery: string,
): CommandPaletteItem[] => {
  return useMemo(() => {
    if (!searchQuery.trim()) {
      return items
    }

    const lowerQuery = searchQuery.toLowerCase()

    return items.filter(item => {
      const labelMatch = item.label.toLowerCase().includes(lowerQuery)
      const sectionMatch = item.sectionLabel?.toLowerCase().includes(lowerQuery)
      return labelMatch || sectionMatch
    })
  }, [items, searchQuery])
}
